export const setStreamingStartdate = "setStreamingStartdate";
export const setStreamingEnddate = "setStreamingEnddate";
export const setDefaultStreamingQuery = "setDefaultStreamingQuery";
export const setStreamingInitStatus = "setStreamingInitStatus";
export const setStreamingColumnTypes = "setStreamingColumnTypes";
export const setStreamingSelectedResults = "setStreamingSelectedResults";
export const setStreamingDomainGroups = "setStreamingDomainGroups";
export const setStreamingColumnFieldsOptions =
  "setStreamingColumnFieldsOptions";
export const setStreamingQuery = "setStreamingQuery";
export const setStreamingQueryForAPI = "setStreamingQueryForAPI";
export const setStreamingResults = "setStreamingResults";
export const setStreamingResultsColumns = "setStreamingResultsColumns";
export const setStreamingSelectedRowsIndex = "setStreamingSelectedRowsIndex";
export const setStreamingAllWithStarSelected =
  "setStreamingAllWithStarSelected";
export const setStreamingResultsCurrentPage = "setStreamingResultsCurrentPage";
export const setStreamingRoFQuery = "setStreamingRoFQuery";
export const setStreamingRoFResults = "setStreamingRoFResults";
export const setStreamingRoFResultsLoadDetails =
  "setStreamingRoFResultsLoadDetails";

export const setStreamingDisplayColumnFieldsOptions =
  "setStreamingDisplayColumnFieldsOptions";
export const setStreamingMeasures = "setStreamingMeasures";
export const setStreamingSumVisible = "setStreamingSumVisible";
export const setStreamingQueryCostData = "setStreamingQueryCostData";

